import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import NtaPaletteLegendIcon from '../Instructions/NtaPaletteLegendIcon';
import { NTA_COLORS } from '../constants';
import { ntaPageCss } from '../typography';
import useNtaPaletteCounts from './useNtaPaletteCounts';

const Legend = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  align-items: center;
  ${ntaPageCss}
`;

const LegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  grid-column: ${({ $fullWidth }) => ($fullWidth ? '1 / -1' : 'auto')};
`;

const LegendText = styled.p`
  margin: 0;
  flex: ${({ $fullWidth }) => ($fullWidth ? 1 : '0 0 auto')};
  color: ${NTA_COLORS.paletteLabel};
  font-size: 16px;
  line-height: 24px;
  white-space: ${({ $nowrap }) => ($nowrap ? 'nowrap' : 'normal')};
  ${ntaPageCss}
`;

const COUNT_KEY = {
  'not-visited': 'notVisited',
  'not-answered': 'notAnswered',
  answered: 'answered',
  'marked-for-review': 'markedForReview',
  'answered-marked': 'answeredMarked'
};

const LEGEND_LABEL = {
  'not-visited': 'Not Visited',
  'not-answered': 'Not Answered',
  answered: 'Answered',
  'marked-for-review': 'Marked for Review',
  'answered-marked':
    'Answered & Marked for Review (will be considered for evaluation)'
};

const TAKING_ORDER = [
  'not-visited',
  'answered',
  'not-answered',
  'marked-for-review',
  'answered-marked'
];

const NtaPaletteLegend = ({ sectionUID }) => {
  const counts = useNtaPaletteCounts(sectionUID);

  return (
    <Legend>
      {TAKING_ORDER.map((key) => {
        const count = counts[COUNT_KEY[key]] ?? 0;
        const isFullWidth = key === 'answered-marked';

        return (
          <LegendRow key={key} $fullWidth={isFullWidth}>
            <NtaPaletteLegendIcon icon={key} count={count} size={32} />
            <LegendText $nowrap={!isFullWidth} $fullWidth={isFullWidth}>
              {LEGEND_LABEL[key]}
            </LegendText>
          </LegendRow>
        );
      })}
    </Legend>
  );
};

export default NtaPaletteLegend;

NtaPaletteLegend.propTypes = {
  sectionUID: PropTypes.string
};
